import React from "react";

const Tabs = ({ activeTab, handleTabChange, badgeCounts, t }) => (
  <div className="flex justify-around gap-5 mt-4">
    <div className="relative flex-1">
      <button
        onClick={() => handleTabChange("sent")}
        className={`w-full py-2 font-semibold text-center rounded-lg cursor-pointer ${
          activeTab === "sent"
            ? "bg-[#6d29f6] text-white"
            : "bg-white text-[#6d29f6] border border-[#6d29f6]"
        }`}
        style={activeTab === "sent" ? { border: "2px solid #6d2af6" } : {}}
      >
        {t("sent")}
      </button>
      <span
        className="absolute right-[-10px] p-3 top-[-10px] bg-red-600 text-white text-sm w-6 h-6 flex items-center justify-center rounded-full border-2 "
        style={{ fontWeight: "bold" }}
      >
        {badgeCounts.send_vibe_count}
      </span>
    </div>
    <div className="relative flex-1">
      <button
        onClick={() => handleTabChange("received")}
        className={`w-full py-2 font-semibold text-center rounded-lg cursor-pointer ${
          activeTab === "received"
            ? "bg-[#6d29f6] text-white"
            : "bg-white text-[#6d29f6] border border-[#6d29f6]"
        }`}
        style={activeTab === "received" ? { border: "2px solid #6d2af6" } : {}}
      >
        {t("received")}
      </button>
      <span
        className="absolute right-[-10px] p-3 top-[-10px] bg-red-600 text-white text-sm w-6 h-6 flex items-center justify-center rounded-full border-2"
        style={{ fontWeight: "bold" }}
      >
        {badgeCounts.receive_vibe_count}
      </span>
    </div>
  </div>
);

export default Tabs;
